<app-spinner
  *ngIf="isSpinnerEnable"
  [isEnable]="true"
  loaderClass="process-spinner"
>
</app-spinner>
<div class="row filters" [formGroup]="model">
  <div class="col-6 grid-columns">
    <div class="row">
      <div class="m-b-5">Business unit</div>
      <app-drilldown
        *ngIf="!businessUnits"
        placeholder="Select Business unit"
        [treeviewEntities]="[]"
      >
      </app-drilldown>
      <app-drilldown
        *ngIf="businessUnits"
        #drilldownSelect
        placeholder="Select Business unit"
        [disableParentSelection]="true"
        [defaultEntityId]="defaultbusinessUnitId"
        [treeviewEntities]="businessUnits"
        (onEntitySelected)="onBusinessUnitSelected($event)"
      >
      </app-drilldown>
    </div>
    <div class="row terms">
      <div class="caption">
        <div class="m-b-5">Begining of the period</div>
        <input
          #launchDate="bsDatepicker"
          formControlName="StartDate"
          bsDatepicker
        />
        <i (click)="launchDate.toggle()" class="fa fa-calendar"></i>
      </div>
      <div class="caption">
        <div class="m-b-5">End of the period</div>
        <input
          #expirationDate="bsDatepicker"
          formControlName="EndDate"
          bsDatepicker
        />
        <i (click)="expirationDate.toggle()" class="fa fa-calendar"></i>
      </div>
    </div>
  </div>
  <div class="col-6 grid-columns">
    <div class="row">
      <div class="m-b-5">Employee</div>
      <ngx-select
        [items]="searchedEmployees"
        [allowClear]="true"
        [multiple]="false"
        optionValueField="id"
        optionTextField="name"
        formControlName="Employee"
        (typed)="searchEmployeeByName($event)"
        placeholder="Select Employee"
      ></ngx-select>
    </div>
    <div class="row status-wrap">
      <input
        class="with-gap blue-radio"
        type="radio"
        [value]="Stages.Active"
        formControlName="Stages"
        id="active-status"
      />
      <label for="active-status">Active</label>
      <input
        class="with-gap blue-radio"
        type="radio"
        [value]="Stages.Completed"
        formControlName="Stages"
        id="completed-status"
      />
      <label for="completed-status">Completed</label>
      <input
        class="with-gap blue-radio"
        type="radio"
        [value]="Stages.All"
        formControlName="Stages"
        id="all-status"
      />
      <label for="all-status">All</label>
    </div>
  </div>
</div>
<div class="row btn">
  <span class="form-btn ok" (click)="download()">Download</span>
  <span class="form-btn" (click)="clearAll()">Clear all</span>
</div>
